import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { getFromNowDate, formatFriendlyDate } from '../../utils/dateUtility';

const RelativeDate = ({ date, text }) => {
  const relativeTime = getFromNowDate(date);
  const placement = "right";

  return (
    <OverlayTrigger
      overlay={
        <Tooltip id={`relative-date-for-${date}`} className={placement}>
          {formatFriendlyDate(date)}
        </Tooltip>
      }
      placement={placement}
    >
      <span>
        {text} {relativeTime}
      </span>
    </OverlayTrigger>
  );
};

RelativeDate.propTypes = {
  date: PropTypes.string.isRequired,
  text: PropTypes.string,
};

export default RelativeDate;
